module.exports = __webpack_public_path__ + "img/balanco_gg.f45651e3.png";